const countries = require('./countries.json');

export const SHIPMENT_COUNTRIES = countries.reduce((acc, country) => {
  acc[country.name] = country.code;
  return acc;
}, {});

export const moreStates = [
  { short: 'AA', name: 'Armed Forces Central and South Americas', country: 'US' },
  { short: 'AE', name: 'Armed Forces Europe', country: 'US' },
  { short: 'AP', name: 'Armed Forces Pacific', country: 'US' },
];
export const COUNTRIES_THAT_REQUIRE_STATES = ['US', 'CA', 'AU', 'BR', 'MX', 'IN', 'CN', 'MY', 'ID', 'PH'];

export const DEFAULT_ADDRESS_FIELDS = ['Contact Name', 'Street 1', 'City', 'State', 'Zip/Postal', 'Country'];
